// extracted by mini-css-extract-plugin
export default {"container":"WelcomeCard_container__gydnA","welcomeMessage":"WelcomeCard_welcomeMessage__OiXKJ","entered":"WelcomeCard_entered__hiNXo","joined":"WelcomeCard_joined__je9Kd"};